const flags = [
    {
        possibleNames: ['ag', 'antigua and barbuda'],
        flag: 'antigua-and-barbuda',
        formattedName: 'Antigua and Barbuda'
    },
    {
        possibleNames: ['bs', 'bahamas'],
        flag: 'bahamas',
        formattedName: 'Bahamas'
    },
    {
        possibleNames: ['bb', 'barbados'],
        flag: 'barbados',
        formattedName: 'Barbados'
    },
    {
        possibleNames: ['be', 'belgium'],
        flag: 'belgium',
        formattedName: 'Belgium'
    },
    {
        possibleNames: ['bz', 'belize'],
        flag: 'belize',
        formattedName: 'Belize'
    },
    {
        possibleNames: ['bm', 'bermuda'],
        flag: 'bermuda',
        formattedName: 'Bermuda'
    },
    {
        possibleNames: ['br', 'brazil'],
        flag: 'brazil',
        formattedName: 'Brazil'
    },
    {
        possibleNames: ['ky', 'cayman islands'],
        flag: 'cayman-islands',
        formattedName: 'Cayman Islands'
    },
    {
        possibleNames: ['cn', 'china'],
        flag: 'china',
        formattedName: 'China'
    },
    {
        possibleNames: ['ck', 'cook islands'],
        flag: 'cook-islands',
        formattedName: 'Cook Islands'
    },
    {
        possibleNames: ['hr', 'croatia'],
        flag: 'croatia',
        formattedName: ''
    },
    {
        possibleNames: ['cu', 'cuba'],
        flag: 'cuba',
        formattedName: 'Cuba'
    },
    {
        possibleNames: ['cw', 'curacao', 'curaçao'],
        flag: 'curacao',
        formattedName: 'Curaçao'
    },
    {
        possibleNames: ['cy', 'cyprus'],
        flag: 'cyprus',
        formattedName: 'Cyprus'
    },
    {
        possibleNames: ['cz', 'czech republic'],
        flag: 'czech-republic',
        formattedName: 'Czech Republic'
    },
    {
        possibleNames: ['dk', 'denmark'],
        flag: 'denmark',
        formattedName: 'Denmark'
    },
    {
        possibleNames: ['fr', 'france'],
        flag: 'france',
        formattedName: 'France'
    },
    {
        possibleNames: ['de', 'germany'],
        flag: 'germany',
        formattedName: 'Germany'
    },
    {
        possibleNames: ['gi', 'gibraltar'],
        flag: 'gibraltar',
        formattedName: 'Gibraltar'
    },
    {
        possibleNames: ['gr', 'greece'],
        flag: 'greece',
        formattedName: 'Greece'
    },
    {
        possibleNames: ['hk', 'hong kong'],
        flag: 'hong-kong',
        formattedName: 'Hong Kong'
    },
    {
        possibleNames: ['id', 'indonesia'],
        flag: 'indonesia',
        formattedName: 'Indonesia'
    },
    {
        possibleNames: ['ir', 'iran'],
        flag: 'iran',
        formattedName: 'Iran'
    },
    {
        possibleNames: ['im', 'iom', 'isle of man'],
        flag: 'isle-of-man',
        formattedName: 'Isle of Man'
    },
    {
        possibleNames: ['il', 'israel'],
        flag: 'israel',
        formattedName: 'Israel'
    },
    {
        possibleNames: ['it', 'italy'],
        flag: 'italy',
        formattedName: 'Italy'
    },
    {
        possibleNames: ['jm', 'jamaica'],
        flag: 'jamaica',
        formattedName: 'Jamaica'
    },
    {
        possibleNames: ['jp', 'japan'],
        flag: 'japan',
        formattedName: 'Japan'
    },
    {
        possibleNames: ['lr', 'liberia'],
        flag: 'liberia',
        formattedName: 'Liberia'
    },
    {
        possibleNames: ['lu', 'luxembourg'],
        flag: 'luxembourg',
        formattedName: 'Luxembourg'
    },
    {
        possibleNames: ['my', 'malaysia'],
        flag: 'malaysia',
        formattedName: 'Malaysia'
    },
    {
        possibleNames: ['mt', 'malta'],
        flag: 'malta',
        formattedName: 'Malta'
    },
    {
        possibleNames: ['mh', 'marshall islands'],
        flag: 'marshall-island',
        formattedName: 'Marshall Islands'
    },
    {
        possibleNames: ['mx', 'mexico'],
        flag: 'mexico',
        formattedName: 'Mexico'
    },
    {
        possibleNames: ['me', 'montenegro'],
        flag: 'montenegro',
        formattedName: 'Montenegro'
    },
    {
        possibleNames: ['nl', 'netherlands'],
        flag: 'netherlands',
        formattedName: 'Netherlands'
    },
    {
        possibleNames: ['ng', 'nigeria'],
        flag: 'nigeria',
        formattedName: 'Nigeria'
    },
    {
        possibleNames: ['no', 'norway', 'norwegian'],
        flag: 'norway',
        formattedName: 'Norway'
    },
    {
        possibleNames: ['pa', 'panama'],
        flag: 'panama',
        formattedName: 'Panama'
    },
    {
        possibleNames: ['ph', 'philippines'],
        flag: 'philippines',
        formattedName: 'Philippines'
    },
    {
        possibleNames: ['pt', 'portugal'],
        flag: 'portugal',
        formattedName: 'Portugal'
    },
    {
        possibleNames: ['qa', 'qatar'],
        flag: 'qatar',
        formattedName: 'Qatar'
    },
    {
        possibleNames: ['sa', 'saudi arabia'],
        flag: 'saudi-arabia',
        formattedName: 'Saudi Arabia'
    },
    {
        possibleNames: ['sg', 'singapore'],
        flag: 'singapore',
        formattedName: 'Singapore'
    },
    {
        possibleNames: ['kr', 'south korea'],
        flag: 'south-korea',
        formattedName: 'South Korea'
    },
    {
        possibleNames: ['es', 'spain'],
        flag: 'spain',
        formattedName: 'Spain'
    },
    {
        possibleNames: ['vc', 'st. vincent & the grenadine', 'st vincent grenadines'],
        flag: 'st-vincent-and-the-grenadines',
        formattedName: 'St. Vincent and the Grenadines'
    },
    {
        possibleNames: ['tw', 'taiwan'],
        flag: 'taiwan',
        formattedName: 'Taiwan'
    },
    {
        possibleNames: ['th', 'thailand'],
        flag: 'thailand',
        formattedName: 'Thailand'
    },
    {
        possibleNames: ['tr', 'turkey'],
        flag: 'turkey',
        formattedName: 'Turkey'
    },
    {
        possibleNames: ['uk', 'gb', 'united kingdom'],
        flag: 'united-kingdom',
        formattedName: 'United Kingdom'
    },
    {
        possibleNames: ['us', 'united states', 'united states of america'],
        flag: 'united-states-of-america',
        formattedName: 'United States'
    },
    {
        possibleNames: ['vu', 'vanuatu'],
        flag: 'vanuatu',
        formattedName: 'Vanuatu'
    }
];

function matchFlag(flag) {
    for (const possibleFlag of flags) {
        if (possibleFlag.possibleNames.includes(flag.toLowerCase())) {
            return [possibleFlag.flag, possibleFlag.formattedName];
        }
    }

    return [flag, null];
}

module.exports = {
    matchFlag
};